import React from 'react';

// Services
import { getEnvironmentApiUrl } from '../../../services/General';

// Hooks
import useHttp from '../../../hooks/useHttp';

// Interfaces
import { AssignedInquiry, PatientInquiryAnswer, PollQuestion } from '../../../interfaces/Poll';
import AnswersPollPatientDialog from '../AnswersPollPatientDialog/AnswersPollPatientDialog';
interface Props {
    patientName: string,
    patient_id: number | undefined,
    assignedInquiry: AssignedInquiry,
    closeModal: () => void
    setFilledDate: (pollID: number, date: string) => void
}

const AnswerAssignedInquiry: React.FC<Props> = ({
    patientName,
    patient_id,
    assignedInquiry,
    setFilledDate,
    closeModal
}) => {

    const { sendRequest: postAnswers } = useHttp();


    const handleClickSend = (questions: PollQuestion[]) => {

        const returnedAnswers: PatientInquiryAnswer[] = [];

        const date = assignedInquiry.assigned_date;
        questions.forEach(question => {
            const answer = question.answers.find(answer => answer?.inquiry_question_id === question.id);
            returnedAnswers.push({
                answer: {
                    description: answer?.description,
                    id: answer?.id,
                    inquiry_question_id: answer?.inquiry_question_id,
                    order: answer?.order ?? 0,
                    value: answer?.value,
                },
                carer_id: null,
                date,
                free_description: answer?.description,
                inquiry_answer_id: answer?.id || null,
                patient_id,
                patient_inquiries_id: assignedInquiry.id,
            });
        });

        postAnswers({
            url: getEnvironmentApiUrl() + 'inquiry/fill',
            method: 'POST',
            body: returnedAnswers,
        }, () => {
            setFilledDate(assignedInquiry.id, date);
            closeModal();
        });

    };

    return (
        <AnswersPollPatientDialog
            patientName={patientName}
            pollID={assignedInquiry.inquiry_id}
            handleClickSend={handleClickSend}
            closeModal={closeModal}
        />
    );
};

export default AnswerAssignedInquiry;